import { Experiment, ExperimentClient } from '@amplitude/experiment-js-client'
import { NoopService } from '../noopService'

const apiKey = import.meta.env.VITE_AMPLITUDE_API_KEY

let amplitude: ExperimentClient

if (apiKey) {
    amplitude = Experiment.initializeWithAmplitudeAnalytics(
        import.meta.env.VITE_AMPLITUDE_API_KEY,
        {
            serverZone: 'EU',
        }
    )
} else {
    amplitude = NoopService.fromService('Experiment')
}

export default amplitude
